// Section 22 design language: state glyphs are shapes plus colour, never colour alone. Each
// glyph carries its word for screen readers and on hover.
import type { PersonFlag } from '../../viewModels';
import { GLYPH_FLAGS } from '../../viewModels';
import { uiText } from '../text/en';

const SHAPE: Record<PersonFlag, string> = {
  hungry: '▽',
  sick: '+',
  injured: '×',
  grieving: '◆',
  pregnant: '◐',
  idle: '○',
  'in-school': '□',
  'in-custody': '▣',
  stunted: '▬',
  child: 'c',
  elder: 'e',
};

/** Flags needing attention use the accent; the rest are muted. */
const ATTENTION = new Set<PersonFlag>(['hungry', 'sick', 'injured']);

export function Glyphs({ flags, words = false }: { flags: readonly PersonFlag[]; words?: boolean }) {
  const shown = GLYPH_FLAGS.filter((f) => flags.includes(f));
  if (shown.length === 0) return null;
  return (
    <span class="glyphs">
      {shown.map((f) => (
        <span
          key={f}
          class={`glyph glyph--${f}${ATTENTION.has(f) ? ' glyph--attention' : ''}`}
          title={uiText.flags[f]}
        >
          <span aria-hidden="true">{SHAPE[f]}</span>
          {words ? (
            <span class="glyph__word"> {uiText.flags[f]}</span>
          ) : (
            <span class="visually-hidden">{uiText.flags[f]}</span>
          )}
        </span>
      ))}
    </span>
  );
}
